import React from 'react'
import { PacmanLoader } from "react-spinners";

export default function Pacmanloader() {
    return (
        <div
          className="sweet-loading"
          style={{ position: "fixed", top: "50%", left: "50%" }}
        >
          <PacmanLoader color={"#20a8d8"} loading={true} />
        </div>
    )
}
